import React from "react";
import { FormattedMessage } from "react-intl";

import { useIntlTranslate } from "../../../../../../hooks";
import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";
import { Icon } from "../../../../../../components/icon/Icon";

export const RulePopupHeader = ({ isEdit, handleClose }) => {
  const headerTextKey = isEdit ? "edit_rule" : "create_new_rule";
  const translate = useIntlTranslate();

  return (
    <div className={"rule-popup__header"}>
      <h4 className={"rule-popup__header__title"}>
        <FormattedMessage id={headerTextKey} />
      </h4>
      <UnstyledButton
        className="rule-popup__header__icon"
        onClick={handleClose}
        aria-label={translate("aria_close")}
      >
        <Icon icon="fa-regular fa-times" />
      </UnstyledButton>
    </div>
  );
};
